import React, { useState, useEffect } from 'react';
import DeleteCrop from './DeleteCrop'; // Adjust path if needed
import DeleteProblem from './DeleteProblem'; // Adjust path if needed
import ViewCrop from './ViewCrop';
import ViewProblem from './ViewProblem';
import ViewHierarchy from './ViewHierarchy';
import AddCrop from './AddCrop';
import AddProblem from './AddProblem';
import EditCrop from './EditCrop';
import EditProblem from './EditProblem';
import EditHierarchy from './EditHierarchy';
import LoginModal from './LoginModal';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
// import { PlusIcon } from 'lucide-react';

const CropDarpanUI = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const [showLogin, setShowLogin] = useState(!isAuthenticated);
  const [activeSidebar, setActiveSidebarState] = useState(() => {
    return localStorage.getItem('activeSidebar') || 'Add Crop';
  });
  const handleSetActiveSidebar = (item) => {
    setActiveSidebarState(item);
    localStorage.setItem('activeSidebar', item);
  };
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'activeSidebar' && e.newValue) setActiveSidebarState(e.newValue);
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  // if (showLogin) {
  //   return <LoginModal onClose={() => setShowLogin(false)} />;
  // }

  if (!isAuthenticated) {
    return <LoginModal onClose={() => { }} />;
  }
  
  // Sidebar items
  const sidebarItems = [
    { group: t('expert.sidebar.crop'), items: ['View Crop', 'Add Crop', 'Edit Crop', 'Delete Crop'] },
    { group: t('expert.sidebar.problem'), items: ['View Problem', 'Add Problem', 'Edit Problem', 'Delete Problem'] },
    { group: t('expert.sidebar.hierarchy'), items: ['View Hierarchy', 'Enter/Update Hierarchy', 'Delete Hierarchy'] }
  ];

  // -----------------------------------------
  // MAIN RETURN
  // -----------------------------------------
  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <div className="w-64 bg-white border-r">
        <div className="p-4 text-xl font-bold border-b">Crop Darpan</div>
        {sidebarItems.map((section, index) => (
          <div key={index} className="mb-4">
            <div className="px-4 py-2 text-gray-500 uppercase text-xs">{section.group}</div>
            {section.items.map((item) => (
              <div
                key={item}
                className={`px-4 py-2 cursor-pointer hover:bg-blue-50 
                  ${activeSidebar === item ? 'bg-blue-100 text-blue-600' : 'text-gray-700'}`}
                onClick={() => handleSetActiveSidebar(item)}
              >
                {t(`expert.sidebar.items.${item.replace(/\s/g, '')}`)}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Main Content */}
      <div className="flex-1 p-6 overflow-y-auto">
        {/* Conditionally render based on activeSidebar */}
        {activeSidebar === 'View Crop' && <ViewCrop />}
        {activeSidebar === 'View Problem' && <ViewProblem />}
        {activeSidebar === 'View Hierarchy' && <ViewHierarchy />}
        {activeSidebar === 'Add Crop' && <AddCrop />}
        {activeSidebar === 'Add Problem' && <AddProblem />}
        {activeSidebar === 'Edit Crop' && <EditCrop />}
        {activeSidebar === 'Edit Problem' && <EditProblem />}
        {activeSidebar === 'Enter/Update Hierarchy' && <EditHierarchy />}
        {activeSidebar === 'Delete Crop' && <DeleteCrop />}
        {activeSidebar === 'Delete Problem' && <DeleteProblem />}
      </div>
    </div>
  );
};

export default CropDarpanUI;